<template>
  <div class="min-h-screen flex flex-col">
    <main class="flex-grow flex flex-col justify-center">
      <slot />
    </main>
  </div>
</template>
